import { InputSliceState } from 'features/input/inputSliceTypes';
import { MatchSliceState } from 'features/match/matchSliceTypes';
import { RootState } from 'rootReducer';

interface GetStateFromThunkAPI {
  matchState: MatchSliceState;
  inputState: InputSliceState;
}

export default function getStatsCountForType(thunkAPI: any): GetStateFromThunkAPI {
  const rootState = thunkAPI.getState() as RootState;
  const matchState = rootState.matchState;
  const inputState = rootState.input;

  return { matchState, inputState };
}
